const ru = {
  message: {
    
  },
};

export default ru;
